angular.module('TetherApp').factory('participantModalService', [
    '$http',
    '$mdDialog',
    '$mdToast',
    'campaignService',
    'listService',
    'eventService',
    function (
        $http,
        $mdDialog,
        $mdToast,
        campaignService,
        listService,
        eventService
    ) {
        let self = this;

        let randomString = function () {
            let result = '';
            let length = 16;
            let chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let editParticipant = function (participant) {
            let uri = '/api/v1/participants/' + participant.Id + '/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.put(
                uri,
                participant,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let getParticipant = function (participantId) {
            return $http.get(
                '/api/v1/participants/' + participantId + '/' + randomString(),
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let getParticipantActivity = function (participantId, page) {
            let parameters = {};
            if (page != undefined) {
                parameters.page = page;
            }
            return $http.get(
                '/api/v1/participant/' + participantId + '/activity/' + randomString(),
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' },
                    params: parameters
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let getParticipantList = function (participantId) {
            return $http.get(
                '/api/v1/participant/' + participantId + '/lists/' + randomString(),
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let getParticipantModal = function(ev, participantId) {
            self.participantModalControllerParticipantId = participantId;
            ParticipantModalController.$inject = ['$mdDialog'];
            return $mdDialog.show({
                controller: ParticipantModalController,
                controllerAs: 'participantModalController',
                templateUrl: '/participant/partials/info-modal',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };

        let getParticipantNotes = function (participantId, notesString) {
            let uri = '/api/v1/participants/' + participantId + '/notes/' + randomString();
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let ParticipantModalController = function ($mdDialog) {
            let dCtrl = this;
            dCtrl.participantId = self.participantModalControllerParticipantId;
            dCtrl.isCreateListFormOpen = false;
            dCtrl.campaigns = [];
            dCtrl.campaignList = [];
            dCtrl.list = {
                name: '',
                campaign_ids: [],
                allow_multiple: false
            };
            dCtrl.openedActivity = [];

            dCtrl.hide = function () {
                $mdDialog.hide();
            };

            dCtrl.cancel = function () {
                $mdDialog.cancel();
            };

            let onParticipant = function (data) {
                dCtrl.participant = data;
            };

            dCtrl.editParticipant = function () {
                editParticipant(dCtrl.participant)
                    .then(onEditParticipant, onError);
            };

            let onEditParticipant = function (data) {
                dCtrl.getActivity(dCtrl.participantId);
                $mdToast.show({
                    hideDelay   : 2000,
                    position    : 'bottom left',
                    template : '<md-toast>' +
                        '<span class="md-toast-text" flex><i style="color:green;" class="fa fa-check" aria-hidden="true"></i> Participant updated!</span>' +
                        '</md-toast>'
                });
            };

            dCtrl.addParticipantToList = function () {
                listService.addParticipantsToList(
                    dCtrl.currentListId,
                    [dCtrl.participantId]
                ).then(
                    function() {
                        getParticipantList(dCtrl.participantId)
                            .then(onParticipantList, onError);
                        dCtrl.currentListId = undefined;
                    },
                    onError
                );
            };

            dCtrl.removeParticipantFromList = function (listId) {
                listService.removeParticipantsFromList(
                    listId,
                    [dCtrl.participantId]
                ).then(
                    function() {
                        getParticipantList(dCtrl.participantId)
                            .then(onParticipantList, onError);
                    },
                    onError
                );
            };

            dCtrl.toggleCreateListForm = function () {
                dCtrl.isCreateListFormOpen = ! dCtrl.isCreateListFormOpen;
            };

            dCtrl.createList = function () {
                if (dCtrl.hasOwnProperty('campaignList')
                    && dCtrl.campaignList.constructor === Array) {
                    dCtrl.campaignList.forEach(function (campaign) {
                        dCtrl.list.campaign_ids.push(campaign.id);
                    });
                }
                listService.createList(dCtrl.list)
                    .then(onCreateList, onError);
            };

            let onCreateList = function (data) {
                $mdToast.show({
                    hideDelay : 2000,
                    position : 'bottom left',
                    template : '<md-toast>' +
                        '<span class="md-toast-text" flex><i style="color:green;" class="fa fa-check" aria-hidden="true"></i> New \'' + dCtrl.list.name + '\' list created!</span>' +
                        '</md-toast>'
                });
                dCtrl.isCreateListFormOpen = false;
                listService.indexList()
                    .then(onClientLists, onError);
            };

            let onParticipantList = function (data) {
                dCtrl.lists = data;
            };

            let onClientLists = function (data) {
                dCtrl.clientLists = data;
                if (dCtrl.list.hasOwnProperty('name')
                    && dCtrl.list.name) {
                    data.forEach(function (list) {
                        if (list.name == dCtrl.list.name) {
                            dCtrl.currentListId = list.id;
                        }
                    });
                    dCtrl.list = {
                        name: '',
                        campaign_ids: [],
                        allow_multiple: false
                    };
                }
            };

            let onCampaignList = function (data) {
                dCtrl.campaigns = data;
            };

            dCtrl.addCampaign = function () {
                let index = -1;
                dCtrl.campaignList.forEach(function (campaign, i) {
                    if (campaign.id == dCtrl.currentCampaign.id) {
                        index = i;
                    }
                });
                // Check if campaign has already been added, if not add it
                if (index == -1) {
                    dCtrl.campaignList.push(dCtrl.currentCampaign);
                }
            };

            dCtrl.removeCampaign = function (campaign) {
                let index = dCtrl.campaignList.indexOf(campaign);
                // Check if campaign exist and remove it
                if (index > -1) {
                    dCtrl.campaignList.splice(index, 1);
                }
            };

            dCtrl.getActivity = function (participantId, page) {
                getParticipantActivity(participantId, page)
                    .then(onActivity, onError);
            };

            let onActivity = function (data) {
                dCtrl.activity = data;
                let pages = [];
                let firstNumber = ((data.current_page - 2) <= 0) ? 1 : data.current_page - 2;
                let lastNumber = firstNumber + 4;
                if (lastNumber > data.last_page) {
                    lastNumber = data.last_page;
                }
                for(let i = firstNumber; i <= lastNumber; i++) {
                    pages.push(i);
                }
                dCtrl.pagination = {};
                dCtrl.pagination.range = pages;
                dCtrl.pagination.total = data.total;
                dCtrl.pagination.current_page = data.current_page;
                dCtrl.pagination.last_page = data.last_page;
                dCtrl.pagination.next_page_url = data.next_page_url;
                dCtrl.pagination.prev_page_url = data.prev_page_url;
                dCtrl.pagination.from = data.from;
                dCtrl.pagination.to = data.to;
            };

            dCtrl.toggleActivity = function (activityId) {
                let activityIndex = dCtrl.openedActivity.indexOf(activityId);
                if (activityIndex > -1) {
                    dCtrl.openedActivity.splice(activityIndex);
                } else {
                    dCtrl.openedActivity.push(activityId);
                }
            };

            dCtrl.isOpenedActivity = function (activityId) {
                return dCtrl.openedActivity.indexOf(activityId) > -1;
            };

            let onParticipantNotes = function (data) {
                dCtrl.notes = data;
            };

            dCtrl.saveParticipantNotes = function () {
                saveParticipantNotes(dCtrl.participant.Id, dCtrl.note)
                    .then(onSaveParticipantNotes, onError);
            };

            let onSaveParticipantNotes = function (data) {
                dCtrl.getActivity(dCtrl.participantId);
                getParticipantNotes(dCtrl.participantId)
                    .then(onParticipantNotes, onError);
                dCtrl.note = '';
                $mdToast.show({
                    hideDelay   : 2000,
                    position    : 'bottom left',
                    template : '<md-toast>' +
                        '<span class="md-toast-text" flex><i style="color:green;" class="fa fa-check" aria-hidden="true"></i> Participant notes updated!</span>' +
                        '</md-toast>'
                });
            };

            dCtrl.requeueEvent = function (eventId) {
                eventService.requeueEmail(eventId)
                    .then(onRequeueEvent, onError);
            };

            let onRequeueEvent = function () {
                $mdToast.show({
                    hideDelay : 2000,
                    position : 'bottom left',
                    template : '<md-toast style="max-width:350px;">' +
                        '<span class="md-toast-text" flex><i style="color:green;" class="fa fa-check" aria-hidden="true"></i> Successfully requeued the event!</span>' +
                        '</md-toast>'
                });
            };

            let onError = function (reason) {
                $mdToast.show({
                    hideDelay   : 2000,
                    position    : 'bottom left',
                    template : '<md-toast>' +
                        '<span class="md-toast-text" flex><i style="color:red;" class="fa fa-times" aria-hidden="true"></i> An error occurred, please contact support.</span>' +
                        '</md-toast>'
                });
            };

            let init = function () {
                listService.indexList()
                    .then(onClientLists, onError);
                campaignService.list()
                    .then(onCampaignList, onError);
                getParticipant(dCtrl.participantId)
                    .then(onParticipant, onError);
                dCtrl.getActivity(dCtrl.participantId);
                getParticipantList(dCtrl.participantId)
                    .then(onParticipantList, onError);
                getParticipantNotes(dCtrl.participantId)
                    .then(onParticipantNotes, onError);
            }();
        };

        let saveParticipantNotes = function (participantId, notesString) {
            let uri = '/api/v1/participants/' + participantId + '/save-notes';
            return $http.put(
                uri,
                {notes: notesString},
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        return {
            getParticipantModal: getParticipantModal
        }

    }
]);
